import React from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import ModalFooter from 'CommonComponents/ModalFooter';
import TextareaFormField from 'CommonComponents/TextareaFormField';
import TextFormField from 'CommonComponents/TextFormField';

const PolicyEditSchema = Yup.object().shape({
    total_cost: Yup.string().required('This value is required'),
    method: Yup.string().required('This value is required'),
    details: Yup.string().required('This value is required'),
});

export default function ProcurementPoliciesEditForm(props) {
    return (
        <Formik
            initialValues={{
                total_cost: props.policy.total_cost || '',
                method: props.policy.method || '',
                details: props.policy.details || '',
            }}
            validationSchema={PolicyEditSchema}
            onSubmit={(values, actions) => {
                axios
                    .put(props.updateUrl.replace('POLICY_ID', props.policy.id), values)
                    .then((response) => {
                        props.setPolicyIsUpdated(true);
                    })
                    .catch((e) => {
                        actions.setErrors(e.response.data.errors);
                    })
                    .finally(() => {
                        actions.setSubmitting(false);
                    });
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                <>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField
                            label={$t('Value')}
                            type="text"
                            required={true}
                            name="total_cost"
                            placeholder={$t('Example: $100,000 to $250,000')}
                        ></TextFormField>
                    </div>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField
                            label={$t('Method')}
                            type="text"
                            required={true}
                            name="method"
                            placeholder={$t('Example: Select tender')}
                        ></TextFormField>
                    </div>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextareaFormField
                            label={$t('Details')}
                            as="textarea"
                            type="text"
                            required={true}
                            name="details"
                            placeholder={$t('Details')}
                        ></TextareaFormField>
                    </div>

                    <ModalFooter
                        cancelButtonText={$t('Cancel')}
                        primaryButtonText={$t('Update')}
                        onCancel={props.internalCloseHandler}
                        handleSubmit={handleSubmit}
                        isSubmitting={props.request}
                    ></ModalFooter>
                </>
            )}
        </Formik>
    );
}
